module.exports = __webpack_public_path__ + "fonts/sk_icons.3599037.woff";